import classnames from 'classnames';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { Small, MediumUp } from 'components/MediaQuery';
import Tabs from 'components/Tabs';
import { small } from 'constants/mediaQueries';
import Theme from 'styles/theme';

import RowsDesktop from './RowsDesktop';
import RowsMobile from './RowsMobile';

class PageSectionShowcase extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { activeRowIndex: 0 };
  }

  handleRowTransition = index => {
    this.setState({ activeRowIndex: index });
  };

  render() {
    const { rows, className } = this.props;
    const { activeRowIndex } = this.state;
    const classes = classnames('PageSectionShowcase', className);
    const tabs = map(rows, ({ tabText }) => tabText);

    return (
      <div className={classes}>
        <div className="PageSectionShowcase__tabs-affix">
          <Tabs tabs={tabs} activeTabIndex={activeRowIndex} />
        </div>
        <Small>
          <RowsMobile
            rows={rows}
            rowRefs={this.rowRefs}
            handleRowTransition={this.handleRowTransition}
          />
        </Small>
        <MediumUp>
          <RowsDesktop
            rows={rows}
            rowRefs={this.rowRefs}
            handleRowTransition={this.handleRowTransition}
            activeRowIndex={activeRowIndex}
          />
        </MediumUp>

        <style jsx>
          {`
            .PageSectionShowcase {
              position: relative;
            }

            .PageSectionShowcase:before {
              content: '';
              width: 4px;
              height: 1px;
              background-color: black;
              position: fixed;
              top: calc(50% - 1px);
            }

            .PageSectionShowcase__tabs-affix {
              position: relative;
              position: sticky;
              z-index: 4;
              top: ${Theme.get('top-navigation-height') - 1}px;
              background-color: ${Theme.get('colors-white')};
              border-bottom: 2px solid ${Theme.get('colors-black-20')};
            }

            @media ${small} {
              .PageSectionShowcase__tabs-affix {
                box-shadow: 0px -2px ${Theme.get('colors-black-20')} inset;
                border-bottom: hidden;
              }
            }
          `}
        </style>

        <style jsx global>
          {`
            .Page.Banner--enabled .PageSectionShowcase__tabs-affix {
              top: ${Theme.get('top-navigation-height')};
            }
          `}
        </style>
      </div>
    );
  }
}

PageSectionShowcase.propTypes = {
  className: PropTypes.string,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      subtext: PropTypes.shape({}).isRequired,
      ctaLinks: PropTypes.arrayOf(
        PropTypes.shape({
          _contentType: PropTypes.string.isRequired,
          internalName: PropTypes.string.isRequired,
          text: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          openInNewWindow: PropTypes.bool.isRequired,
        })
      ),
      desktopImages: PropTypes.arrayOf(
        PropTypes.shape({
          file: PropTypes.shape({
            cloudinaryPublicId: PropTypes.string,
            details: PropTypes.shape({
              image: PropTypes.shape({
                height: PropTypes.number,
                width: PropTypes.number,
              }),
            }),
          }),
        })
      ),
      desktopImage: PropTypes.shape({
        file: PropTypes.shape({
          cloudinaryPublicId: PropTypes.string,
          details: PropTypes.shape({
            image: PropTypes.shape({
              height: PropTypes.number,
              width: PropTypes.number,
            }),
          }),
        }),
      }),
      mobileImages: PropTypes.arrayOf(
        PropTypes.shape({
          file: PropTypes.shape({
            cloudinaryPublicId: PropTypes.string,
            details: PropTypes.shape({
              image: PropTypes.shape({
                height: PropTypes.number,
                width: PropTypes.number,
              }),
            }),
          }),
        })
      ),
      mobileImage: PropTypes.shape({
        file: PropTypes.shape({
          cloudinaryPublicId: PropTypes.string,
          details: PropTypes.shape({
            image: PropTypes.shape({
              height: PropTypes.number,
              width: PropTypes.number,
            }),
          }),
        }),
      }),
    })
  ).isRequired,
};

PageSectionShowcase.defaultProps = {
  className: '',
};

export default PageSectionShowcase;
